// src/padplanner/lineVocabulary.js
//
// A line's type (S6b prerequisite 1, roads first): access_road, flowline,
// power or other, stored as the feature's layer, which is what S5's rule
// selectors match ({"layer":"access_road"}) and what 156's engine selects a
// line by. The server takes no other layer for a line
// (admin-api/lib/padplanner/features.js LINE_TYPES). A disturbance width is
// optional, entered only, and kept in props.width_ft (151 keeps width_ft for
// footprints); distances are to the centerline either way.
//
// The colors are the map's: one set over imagery and the basemap, and one
// for Paper on a light sheet (a dark sheet takes the imagery set).
export const LINE_TYPES = Object.freeze(["access_road", "flowline", "power", "other"]);
export const DEFAULT_LINE_TYPE = "access_road";
export const LINE_TYPE_LABELS = Object.freeze({ access_road: "Access road", flowline: "Flowline", power: "Power", other: "Other" });
export const LINE_COLORS = Object.freeze({ access_road: "#f59e0b", flowline: "#38bdf8", power: "#c084fc", other: "#e5e7eb" });
export const LINE_COLORS_LIGHT_PAPER = Object.freeze({ access_road: "#b45309", flowline: "#0369a1", power: "#7e22ce", other: "#3f3f46" });

/** A line's type, as a person reads it; an unknown layer reads as itself. */
export const lineTypeLabel = (layer) => LINE_TYPE_LABELS[layer] ?? layer ?? "Line";

/** A line's disturbance width in feet, or null (none entered). */
export const lineWidthFt = (f) => (typeof f?.props?.width_ft === "number" ? f.props.width_ft : null);
